"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.item = exports.wrapper = void 0;

var _util = require("../../../util");

const wrapper = ({
  theme
}) => ({
  backgroundColor: (0, _util.color)(theme, 'background.default')
});

exports.wrapper = wrapper;

const item = ({
  theme,
  cssProps
}) => {
  const {
    isActive
  } = cssProps;
  return {
    borderRadius: '50%',
    width: 40,
    height: 40,
    cursor: 'pointer',
    ...(isActive && {
      background: (0, _util.color)(theme, 'background.black')
    })
  };
};

exports.item = item;
//# sourceMappingURL=RangePicker.style.js.map